export const welcomeContent = {
  title: "Welcome, Stranger!",
  message: "I'm Alexandr Goriainov, an aspiring young creator with big dreams!",
  instructions: [
    "🏆 Explore my achievements and awards",
    "🎨 Browse my artwork collection", 
    "📖 Learn more about me",
    "📧 Get in touch"
  ],
  controls: "Use WASD or arrow keys to move around and click on objects to interact!"
};

export const aboutContent = {
  title: "About Me",
  introduction: "Hello! I'm Alexandr Goriainov, a creative and curious student who loves:",
  interests: [
    "🎨 Creating art in all forms",
    "📚 Learning new things every day", 
    "🔬 Science experiments and discoveries",
    "🎭 Theater and performance"
  ],
  goal: "My goal is to use creativity and technology to make the world a better place!"
};

export const contactContent = {
  title: "Let's Connect!",
  message: "Want to collaborate or just say hi? Here's how to reach me:",
  contacts: [
    { platform: "Email", handle: "goriainovalexandr@gmail.com", emoji: "📧" },
  ],
  closing: "I'd love to hear from you!"
};
